import PropTypes from 'prop-types';
import { useState } from 'react';

import { ListPaginated } from '@febos-io/design';

import { useCompanyUserListEffect } from '../hooks';

const LIMIT = 10;

export function UserList({ HeaderComponent, RowComponent }) {
  const [page, setPage] = useState(1);
  const {
    loading,
    elements,
    meta: {
      pages
    }
  } = useCompanyUserListEffect(page, LIMIT);

  return (
    <ListPaginated
      HeaderComponent={HeaderComponent}
      RowComponent={RowComponent}
      currentPage={page}
      onPageChange={setPage}
      pages={pages}
      loading={loading}
      elements={elements}
    />
  );
}

export default UserList;

UserList.propTypes = {
  HeaderComponent: PropTypes.elementType,
  RowComponent: PropTypes.elementType.isRequired
};
